// extracted by mini-css-extract-plugin
module.exports = {"overlayClass":"AiUserInfo_overlayClass__goYFv"};